<!-- group-create-modal.component.html -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-500 bg-opacity-50"
  *ngIf="isOpen"
>
  <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
    <h2 class="text-xl font-semibold mb-4">Create Group</h2>
    <form [formGroup]="groupForm" (ngSubmit)="openConfirmationModal()">
      <div class="mb-4">
        <label for="title" class="block text-sm font-medium text-gray-700">Title *</label>
        <input
          id="title"
          formControlName="title"
          class="mt-1 p-2 w-full border border-gray-300 rounded-md"
          (input)="capitalizeInput($event)"
        />
        <div
          *ngIf="getControl('title')?.invalid && getControl('title')?.touched"
          class="text-red-600 mt-1"
        >
          Title is required.
        </div>
      </div>
      <div class="mb-4">
        <label for="description" class="block text-sm font-medium text-gray-700"
          >Description *</label
        >
        <textarea
          id="description"
          formControlName="description"
          class="mt-1 p-2 w-full border border-gray-300 rounded-md"
          (input)="capitalizeInput($event)"
        ></textarea>
        <div
          *ngIf="getControl('description')?.invalid && getControl('description')?.touched"
          class="text-red-600 mt-1"
        >
          Description is required.
        </div>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Add Users</label>
        <input
          type="text"
          formControlName="userSearch"
          class="mb-2 p-2 w-full border border-gray-300 rounded-md"
          placeholder="Search users..."
          (input)="capitalizeInput($event)"
        />
        <div class="relative">
          <div
            *ngIf="searchQuery && filteredUsers.length > 0"
            class="absolute left-0 right-0 z-10 w-full bg-white border border-gray-300 rounded-md mt-0 max-h-60 overflow-auto"
          >
            <div
              *ngFor="let user of filteredUsers"
              (click)="onUserSelect(user)"
              class="p-2 hover:bg-gray-200 cursor-pointer"
            >
              <div class="flex items-center">
                <div
                  class="flex-shrink-0 h-8 w-8 bg-gray-200 rounded-full flex items-center justify-center mr-2"
                >
                  {{ user.first_name.charAt(0) }}{{ user.last_name.charAt(0) }}
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900">
                    {{ user.first_name }} {{ user.last_name }}
                  </p>
                  <p class="text-xs text-gray-500">{{ user.username }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedUsers.length > 0" class="mt-4">
          <h3 class="text-sm font-medium text-gray-700">Selected Users</h3>
          <div class="flex flex-wrap">
            <div
              *ngFor="let user of selectedUsers"
              class="m-1 p-2 bg-gray-200 rounded-md flex items-center"
            >
              {{ user.first_name }} {{ user.last_name }}
              <button type="button" (click)="removeUser(user)" class="ml-2 text-red-600">×</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Select for algorithms -->
      <!-- <div class="mb-4">
        <label for="algorithm" class="block text-sm font-medium text-gray-700">Select Algorithm</label>
        <select id="algorithm" formControlName="algorithm" class="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm">
          <option value="" disabled selected>Options</option>
          <option value="Positional Voting">Positional Voting</option>
          <option value="Non-Positional Voting">Non-Positional Voting (Schulze Method)</option>
        </select>
        <div *ngIf="getControl('algorithm')?.invalid && getControl('algorithm')?.touched" class="text-red-600 mt-1">
          You must select an algorithm.
        </div>
      </div> -->
      <div class="flex justify-end">
        <button
          type="button"
          (click)="closeModal()"
          class="mr-2 px-4 py-2 bg-red-500 text-white rounded-md cursor-pointer hover:bg-red-800"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 text-white rounded-md"
          [ngClass]="{
            'bg-gray-400 cursor-not-allowed': groupForm.invalid || selectedUsers.length === 0,
            'bg-primary_tailwind cursor-pointer hover:bg-red-500': !(
              groupForm.invalid || selectedUsers.length === 0
            ),
          }"
          [disabled]="groupForm.invalid || selectedUsers.length === 0"
        >
          Create Group
        </button>
      </div>
      <p class="text-xs text-gray-500 mt-2">
        The "Create Group" button will only be enabled if at least one user is added.
      </p>
    </form>
  </div>
</div>

<!-- Confirmation Modal -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-500 bg-opacity-50"
  *ngIf="isConfirmationModalOpen"
>
  <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
    <h2 class="text-xl font-semibold mb-4">Confirm Group Creation</h2>
    <p class="mb-4">
      Once the group is created, you will not be able to edit the group details or add more users.
      Are you sure you want to create this group?
    </p>
    <div class="flex justify-end">
      <button
        type="button"
        (click)="closeConfirmationModal()"
        class="mr-2 px-4 py-2 bg-gray-500 text-white rounded-md cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmCreateGroup()"
        class="px-4 py-2 bg-red-500 text-white rounded-md cursor-pointer"
      >
        Confirm
      </button>
    </div>
  </div>
</div>
